import React from "react";
import { Flex, Box, Container } from "@chakra-ui/react";
import UsersList from "views/admin/Users/components/UsersList";

const Users = () => {

  return (
   <Container maxW="xxl" mt={100} p={{ base: 4, md: 8 }}>
<UsersList />      
      </Container>
  );
};

export default Users;
